module.exports = __webpack_public_path__ + "img/credit-cards-logos.0653cbc5.png";